const LoggingConstants = {
  LOG: 'LOG'
};

export default LoggingConstants;